module.exports = __webpack_public_path__ + "img/编组3.fb585f66.png";